import { Box, Tooltip, Chip, IconButton } from '@mui/material';
import { Phone, PhoneDisabled, BugReport } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { useVoIP } from '../hooks/useVoIP';
import { UAState } from '../types';

export const VoIPStatusIndicator = () => {
  const { t } = useTranslation();
  const { uaState, hasJsSipExtension, isRegistered, showDebugPanel, toggleDebugPanel } = useVoIP();

  if (!hasJsSipExtension) {
    return null;
  }

  const getStatusColor = () => {
    if (isRegistered) return 'success';
    if (uaState === UAState.CONNECTING) return 'warning';
    return 'error';
  };

  const getStatusLabel = () => {
    switch (uaState) {
      case UAState.REGISTERED:
        return t('voip.status_connected');
      case UAState.CONNECTING:
        return t('voip.status_connecting');
      case UAState.REGISTRATION_FAILED:
        return t('voip.status_connection_failed');
      default:
        return t('voip.status_offline');
    }
  };

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
      <Tooltip title={getStatusLabel()}>
        <Chip
          icon={isRegistered ? <Phone /> : <PhoneDisabled />}
          label={isRegistered ? t('voip.status_label') : null}
          color={getStatusColor()}
          size="small"
          sx={{ ml: 1 }}
        />
      </Tooltip>
      <Tooltip title={showDebugPanel ? t('voip.debug_panel_hide') : t('voip.debug_panel_show')}>
        <IconButton
          size="small"
          onClick={toggleDebugPanel}
          sx={{
            width: 24,
            height: 24,
            color: showDebugPanel ? 'primary.main' : 'action.disabled',
            '&:hover': {
              color: 'primary.main',
            },
          }}
        >
          <BugReport sx={{ fontSize: 16 }} />
        </IconButton>
      </Tooltip>
    </Box>
  );
};
